import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { capitalize } from "@mui/material";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { SupportTypeCellRenderer } from "../column-def-cell-renderers/SupportTypeCellRenderer";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { FilteredEksResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const eksColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef(),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("eks"),

  {
    field: "resource.support_type",
    headerName: "Support Type",
    headerTooltip: "Extended support period has additional hourly cost.",
    cellRenderer: ({ data }: ICellRendererParams<FilteredEksResourceItem>) => {
      return (
        <SupportTypeCellRenderer
          supportType={data?.resource?.support_type}
          expirationDate={data?.resource?.support_type_expiration ?? undefined}
        />
      );
    },
  },

  {
    field: "resource.upgrade_policy",
    headerName: "Upgrade Policy",
    cellRenderer: ({ data }: ICellRendererParams<FilteredEksResourceItem>) => {
      return capitalize(data?.resource?.upgrade_policy ?? "-");
    },
  },
  {
    field: "resource.version",
    headerName: "Version",
    cellRenderer: ({ data }: ICellRendererParams<FilteredEksResourceItem>) => {
      return capitalize(data?.resource?.version ?? "-");
    },
  },

  resourceAccountColumnDef,

  resourceTotalSpendColumnDef,

  {
    field: "resource.instances_count",
    headerName: "Node Groups/Pools Count",
  },
  {
    field: "resource.node_count",
    headerName: "Node Count",
  },

  getResourceCreationTimeColumnDef("Launch time"),

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
